import { ExerciseData } from '../exercises';
import { exerciseData1Completed } from './module1/Module1Completed';
import { exerciseData11 } from './module1/Module1Exercise1';
import { exerciseData12 } from './module1/Module1Exercise2';
import { exerciseData13 } from './module1/Module1Exercise3';
import { exerciseData14 } from './module1/Module1Exercise4';
import { exerciseData21 } from './module2/Module2Exercise1';
import { exerciseData22 } from './module2/Module2Exercise2';
import { exerciseData23 } from './module2/Module2Exercise3';
import { exerciseData23Completed } from './module2/Module2Exercise3Completed';
import { exerciseData24 } from './module2/Module2Exercise4';
import { exerciseData25 } from './module2/Module2Exercise5';
import { exerciseData26 } from './module2/Module2Exercise6';
import { exerciseData27 } from './module2/Module2Exercise7';
import { exerciseData28 } from './module2/Module2Exercise8';
import { exerciseData29 } from './module2/Module2Exercise9';
import { exerciseData310 } from './module3/Module3Exercise1DetailsView';
import { exerciseData311 } from './module3/Module3Exercise1Part1';
import { exerciseData312 } from './module3/Module3Exercise1Part2';
import { exerciseData313 } from './module3/Module3Exercise1Part3';
import { exerciseData314 } from './module3/Module3Exercise1Part4';
import { exerciseData31Completed } from './module3/Module3Exercise1Completed';
import { exerciseData32 } from './module3/Module3Exercise2';
import { exerciseData33 } from './module3/Module3Exercise3';
import { exerciseData33Completed } from './module3/Module3Exercise3Completed';
import { exerciseData34 } from './module3/Module3Exercise4';
import { exerciseData34Completed } from './module3/Module3Exercise4Completed';
import { exerciseData41 } from './module4/Module4Exercise1';
import { exerciseData41Completed } from './module4/Module4Exercise1Completed';
import { exerciseData42 } from './module4/Module4Exercise2';
import { exerciseData43 } from './module4/Module4Exercise3';
import { exerciseData44 } from './module4/Module4Exercise4';
import { exerciseData45 } from './module4/Module4Exercise5';
import { exerciseData91 } from './intro-module/IntroModuleJonasArticle';
import { exerciseData93 } from './intro-module/IntroModuleExercise3';
import { exerciseData94 } from './intro-module/IntroModuleExercise4';
import { exerciseData15 } from './module1/Module1Exercise5';

export function getExerciseData(code: string): ExerciseData {
    switch (code) {
        case '1.1':
            return exerciseData11;
        case '1.2':
            return exerciseData12;
        case '1.3':
            return exerciseData13;
        case '1.4':
            return exerciseData14;
        case '1.5':
            return exerciseData15;
        case '1.completed':
            return exerciseData1Completed;
        case '2.1':
            return exerciseData21;
        case '2.2':
            return exerciseData22;
        case '2.3':
            return exerciseData23;
        case '2.3.completed':
            return exerciseData23Completed;
        case '2.4':
            return exerciseData24;
        case '2.5':
            return exerciseData25;
        case '2.6':
            return exerciseData26;
        case '2.7':
            return exerciseData27;
        case '2.8':
            return exerciseData28;
        case '2.9':
            return exerciseData29;
        case '3.1.0':
            return exerciseData310;
        case '3.1.1':
            return exerciseData311;
        case '3.1.2':
            return exerciseData312;
        case '3.1.3':
            return exerciseData313;
        case '3.1.4':
            return exerciseData314;
        case '3.1.completed':
            return exerciseData31Completed;
        case '3.2':
            return exerciseData32;
        case '3.3':
            return exerciseData33;
        case '3.3.completed':
            return exerciseData33Completed;
        case '3.4':
            return exerciseData34;
        case '3.4.completed':
            return exerciseData34Completed;
        case '4.1':
            return exerciseData41;
        case '4.1.completed':
            return exerciseData41Completed;
        case '4.2':
            return exerciseData42;
        case '4.3':
            return exerciseData43;
        case '4.4':
            return exerciseData44;
        case '4.5':
            return exerciseData45;
        case '9.1':
            return exerciseData91;
        case '9.3':
            return exerciseData93;
        case '9.4':
            return exerciseData94;
    }
}
